import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';

import HomeLayout from './components/layout/HomeLayout';
import { useEstateStore } from './stores/useEstate.store';
import { getAgentList, getEstates, getVarietalList } from './network/api.service';
import { useMasterStore } from './stores/useMaster.store';
import Modal from './components/modal/Modal';
// import { toast } from 'sonner';

function App() {
  const [loading, setLoading] = useState(false);
  const setEstates = useEstateStore(state => state.setEstates);
  const setVarietalList = useMasterStore(state => state.setVarietalList);
  const setAgentList = useMasterStore(state => state.setAgentList);
  const agentList = useMasterStore(state => state.agentList);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Run all API calls in parallel
  //       const [estatesResponse, varietalListResponse, agentListResponse] = await Promise.all([
  //         getEstates(),
  //         getVarietalList(),
  //         getAgentList(),
  //       ]);

  //       setEstates(estatesResponse.data?.data);
  //       setVarietalList(varietalListResponse.data?.data);
  //       setAgentList(agentListResponse.data?.data);
  //     } catch (error) {
  //       console.error('Error fetching initial data:', error);
  //       // toast.error('Failed to load app data');
  //     } finally {
  //       // setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true);
      try {
        // Prepare API calls array
        const apiCalls = [getEstates(), getVarietalList(), getAgentList()];

        // Only fetch agentList if it doesn't exist in store (from localStorage)
        // if (!agentList) {
        //   apiCalls.push(getAgentList());
        // }

        // Run API calls in parallel
        const responses = await Promise.all(apiCalls);

        setEstates(responses[0].data?.data);
        setVarietalList(responses[1].data?.data);

        // Only set agentList if we fetched it
        if (responses[2]) {
          setAgentList(responses[2].data?.data);
        }
        // if (!agentList && responses[2]) {
        //   setAgentList(responses[2].data?.data);
        // }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        // toast.error('Failed to load app data');
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <HomeLayout>
      <Outlet />
      <ErrorBoundary />
      <Modal />
    </HomeLayout>
  );
}

export default App;
